/**
 * 解析url参数
 * @param {*} variable
 */
export const getQueryVariable = function(variable) {
  var query = window.location.search.substring(1)
  var vars = query.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (pair[0] == variable) {
      return pair[1]
    }
  }
  return false
}

/**
 * 针对cookie 设置、获取、删除
 * @param {*} cname
 * @param {*} cvalue
 * @param {*} exdays
 */
export const setCookie = function(cname, cvalue, exdays) {
  var d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  var expires = 'expires=' + d.toUTCString()
  var domain = location.hostname || 'act.dota2.com.cn'
  document.cookie =
    cname +
    '=' +
    cvalue +
    ';' +
    expires +
    ';path=/;domain=.' +
    domain +
    ';' +
    expires
}
export const getCookie = function(cname) {
  var name = cname + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

export const delCookie = function(name) {
  var exp = new Date()
  exp.setTime(exp.getTime() - 1)
  var expires = 'expires=' + exp.toUTCString()
  var domain = location.hostname || 'act.dota2.com.cn'
  var cval = this.getCookie(name)
  document.cookie =
    name +
    '=' +
    cval +
    ';' +
    expires +
    ';path=/;domain=.' +
    domain +
    ';' +
    expires
}

/**
 * 微信分享
 * @param {*} options
 */

export const wx_share = function(options) {
  let shareTitle = options.shareTitle
  let shareInfo = options.shareInfo
  let shareUrl = options.shareUrl
  let jurl = '/weixinShare?url=' + encodeURIComponent(location.href)
  let mxhr = new XMLHttpRequest()
  mxhr.onreadystatechange = function() {
    if (mxhr.readyState == 4 && mxhr.status == 200) {
      mkWxShare(JSON.parse(mxhr.responseText))
    }
  }
  mxhr.open('GET', jurl, true)
  mxhr.send()
  let wx = window.wx
  function wxready() {
    wx.ready(function() {
      //分享给朋友
      wx.onMenuShareAppMessage({
        title: shareTitle, // 分享标题
        desc: shareInfo, // 分享描述
        link: location.href, // 分享链接
        imgUrl: shareUrl, // 分享图标
        type: '', // 分享类型,music、video或link，不填默认为link
        success: function() {
          // 用户确认分享后执行的回调函数
        },
        fail: function() {},
        cancel: function() {},
      })

      //分享到朋友圈
      wx.onMenuShareTimeline({
        title: shareTitle, // 分享标题
        link: location.href, // 分享链接
        imgUrl: shareUrl, // 分享图标
        success: function() {
          // 用户确认分享后执行的回调函数
        },
        fail: function() {},
        cancel: function() {},
      })

      //分享到QQ
      wx.onMenuShareQQ({
        title: shareTitle, // 分享标题
        desc: shareInfo, // 分享描述
        link: location.href, // 分享链接
        imgUrl: shareUrl, // 分享图标
        success: function() {
          // 用户确认分享后执行的回调函数
        },
        fail: function() {},
        cancel: function() {
          // 用户取消分享后执行的回调函数
        },
      })
    })
  }

  function mkWxShare(cbObj) {
    if (cbObj.status == 'failed') {
      return
    }
    let data = cbObj.data
    wx.config({
      debug: false,
      appId: data.appId,
      timestamp: data.timestamp,
      nonceStr: data.nonceStr,
      signature: data.signature,
      jsApiList: [
        'onMenuShareTimeline',
        'onMenuShareAppMessage',
        'onMenuShareQQ',
      ],
    })
    wxready()
  }
}

/**
 * 是否是移动端
 */

export const isMobile = function() {
  var userAgentInfo = navigator.userAgent
  var Agents = new Array(
    'Android',
    'iPhone',
    'SymbianOS',
    'Windows Phone',
    'iPad',
    'iPod',
    'Windows CE',
    'BlackBerry'
  )
  var flag = false
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = true
      break
    }
  }
  return flag
}

/* 调用wmapp
 */

export const steamApp = (function() {
  const u = navigator.userAgent
  const Browser = {
    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
    android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, // android终端或uc浏览器
  }
  if (Browser.ios) {
    return window.webkit && window.webkit.messageHandlers.steamApp
  } else if (Browser.android) {
    return window.steamApp
  }
})()
